export const maskEmail = email => {
  const FIRST_LETTER = email.substr(0, 1);
  const AT_SYMBOL    = email.indexOf('@');

  return `${FIRST_LETTER}****${email.substr(AT_SYMBOL)}`;
};

